/**
 * Deterministic noise. A value is a pure function of (seed, key), never of
 * call order, so the same day for the same tenant is the same number whichever
 * screen asks first — and tests can assert exact figures.
 */

export function hashString(value: string): number {
  let hash = 0x811c9dc5
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index)
    hash = Math.imul(hash, 0x01000193)
  }
  return hash >>> 0
}

/** A uniform number in [0, 1) for this seed and key (one mulberry32 step). */
export function unitNoise(seed: number, ...key: Array<string | number>): number {
  let state = ((seed ^ hashString(key.join('|'))) + 0x6d2b79f5) >>> 0
  state = Math.imul(state ^ (state >>> 15), state | 1)
  state ^= state + Math.imul(state ^ (state >>> 7), state | 61)
  return ((state ^ (state >>> 14)) >>> 0) / 4294967296
}

/** A multiplier in [1 − amplitude, 1 + amplitude]. */
export function wobble(seed: number, amplitude: number, ...key: Array<string | number>): number {
  return 1 + (unitNoise(seed, ...key) * 2 - 1) * amplitude
}
